"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/builtin/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/builtin/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/builtin/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/builtin/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/builtin/possibleConstructorReturn"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/builtin/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var styles = function styles(theme) {
  return {
    root: {
      position: 'relative'
    },
    button: {
      margin: theme.spacing.unit,
      color: theme.palette.text.secondary,
      transition: "".concat(theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter
      }), ", opacity 0.8s"),
      opacity: 1
    },
    buttonClosed: {
      opacity: 0,
      transform: 'scale(0)'
    }
  };
};

var SpeedDialAction =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SpeedDialAction, _React$Component);

  function SpeedDialAction() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, SpeedDialAction);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = SpeedDialAction.__proto__ || Object.getPrototypeOf(SpeedDialAction)).call.apply(_ref, [this].concat(args))), _this.state = {
      tooltipOpen: false
    }, _this.handleTooltipClose = function () {
      _this.setState({
        tooltipOpen: false
      });
    }, _this.handleTooltipOpen = function () {
      _this.setState({
        tooltipOpen: true
      });
    }, _temp));
  }

  (0, _createClass2.default)(SpeedDialAction, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          ButtonProps = _props.ButtonProps,
          classes = _props.classes,
          classNameProp = _props.className,
          delay = _props.delay,
          icon = _props.icon,
          id = _props.id,
          onClick = _props.onClick,
          open = _props.open,
          tooltipTitle = _props.tooltipTitle,
          other = (0, _objectWithoutProperties2.default)(_props, ["ButtonProps", "classes", "className", "delay", "icon", "id", "onClick", "open", "tooltipTitle"]);
      return _react.default.createElement(_Tooltip.default, (0, _extends2.default)({
        id: id,
        className: (0, _classnames.default)(classes.root, classNameProp),
        title: tooltipTitle,
        placement: "left",
        onClose: this.handleTooltipClose,
        onOpen: this.handleTooltipOpen,
        open: open && this.state.tooltipOpen
      }, other), _react.default.createElement(_Button.default, (0, _extends2.default)({
        variant: "fab",
        mini: true,
        className: (0, _classnames.default)(classes.button, !open && classes.buttonClosed),
        style: {
          transitionDelay: "".concat(delay, "ms")
        },
        onClick: onClick,
        tabIndex: -1,
        role: "menuitem",
        "aria-labelledby": id
      }, ButtonProps), icon));
    }
  }]);
  return SpeedDialAction;
}(_react.default.Component);

SpeedDialAction.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Properties applied to the `Button` component.
   */
  ButtonProps: _propTypes.default.object,

  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Adds a transition delay, to allow a series of SpeedDialActions to be animated.
   */
  delay: _propTypes.default.number,

  /**
   * The Icon to display in the SpeedDial Floating Action Button.
   */
  icon: _propTypes.default.node.isRequired,

  /**
   * @ignore
   */
  id: _propTypes.default.string,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * @ignore
   */
  open: _propTypes.default.bool,

  /**
   * Label to display in the tooltip.
   */
  tooltipTitle: _propTypes.default.node
} : {};
SpeedDialAction.defaultProps = {
  delay: 0,
  open: false
};

var _default = (0, _styles.withStyles)(styles)(SpeedDialAction);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/SpeedDialAction/SpeedDialAction.js
// module id = 518
// module chunks = 0